module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-circle-96c030bfc3e2f07dccd02980c6623815.svg";